export enum BuyingGroupMode {
  imageUpload = 'imageUpload'
}

export enum BuyingGroupSettingViews {
  Images = 'images',
  Campaign = 'campaign',
  DeliveryWindow = 'deliveryWindow',
  Drops = 'drops',
  Clients = 'clients',
  SyncBSGData = 'syncBSGData',
  WorldWide = 'worldwide',
  SalesDocType = 'salesDocType',
  BuyingSessionDate = 'buyingSessionDate',
  SalesPeriods = 'salesPeriods',
  DeleteBuyingSessionGroup = 'deleteBuyingSessionGroup'
}

export enum BuyingGroupSettingSectionName {
  Images = 'images',
  Campaign = 'campaign',
  DeliveryWindow = 'deliveryWindow',
  Drops = 'drops',
  Clients = 'clients',
  SyncBSGData = 'syncBSGData',
  WorldWide = 'worldWide',
  SalesDocType = 'salesDocType',
  BuyingSessionDate = 'buyingSessionDate',
  DeleteBuyingSessionGroup = 'deleteBuyingSessionGroup'
}

export enum BuyingGroupSettingsDisplayName {
  WorldWide = 'WORLDWIDE',
  Images = 'Images',
  Campaign = 'Campaign',
  DeliveryWindow = 'Delivery Window',
  Drops = 'Drops',
  Clients = 'Clients',
  SyncBSGData = 'Sync Data',
  SalesDocType = 'Sales Doc Type',
  BuyingSessionDate = 'Price Validity Date',
  DeleteBuyingSessionGroup = 'Delete Buying Session Group'
}
